const CATEGORY_DEFAULTS = {
  FOOD_SERVICE: {
    category: "Food Service",
    agencies: [
      "FDA (Food Code Guidance)",
      "Local/County Health Department",
      "State Department of Health",
      "OSHA"
    ],
    regulations: [
      "State-Adopted FDA Food Code",
      "Local Food Service Sanitation Rules",
      "Employee Health and Hygiene Requirements"
    ],
    registrations: [
      "Business Registration",
      "EIN",
      "Sales Tax Registration (state)"
    ],
    permits: [
      "Food Service Establishment Permit",
      "Health Department Permit"
    ],
    documents: [
      "Food Handler Certifications",
      "Temperature Logs",
      "Cleaning and Sanitization Logs",
      "Approved Supplier Records",
      "Pest Control Records"
    ],
    inspection_type: "Periodic Local Health Inspection",
    risk_level: "High",
    next_steps: [
      "Confirm local health department permit requirements",
      "Establish food safety and sanitation SOPs",
      "Train staff and maintain certification records",
      "Implement daily temperature and cleaning logs",
      "Prepare for local inspection"
    ]
  },
  MANUFACTURING: {
    category: "Manufacturing",
    agencies: ["FDA", "State Department of Agriculture", "OSHA"],
    regulations: [
      "Food Safety Modernization Act (FSMA)",
      "21 CFR Part 117 (cGMP and Preventive Controls)",
      "21 CFR Part 101 (Food Labeling)"
    ],
    registrations: [
      "Business Registration",
      "EIN",
      "FDA Food Facility Registration"
    ],
    permits: ["State Food Manufacturing License"],
    documents: [
      "Food Safety Plan",
      "Recall Plan",
      "Allergen Control Program",
      "Supplier Verification Records",
      "Production Records"
    ],
    inspection_type: "Routine FDA or State Inspection",
    risk_level: "Medium",
    next_steps: [
      "Register with FDA and applicable state agencies",
      "Build preventive controls program",
      "Validate labeling and allergen controls",
      "Train personnel on GMP and records",
      "Run internal inspection readiness audit"
    ]
  },
  MEAT_PROCESSING: {
    category: "Meat Processing",
    agencies: ["USDA FSIS", "State Department of Agriculture", "OSHA"],
    regulations: [
      "Federal Meat Inspection Act (FMIA)",
      "9 CFR Subchapter A (FSIS Requirements)",
      "Sanitation Performance Standards (9 CFR 416)",
      "HACCP Systems (9 CFR 417)"
    ],
    registrations: [
      "Business Registration",
      "EIN",
      "USDA Grant of Inspection"
    ],
    permits: [
      "State Meat Processing License",
      "Environmental Permits (as applicable)"
    ],
    documents: [
      "HACCP Plan",
      "Sanitation SOPs",
      "Recall Plan",
      "Corrective Action Records",
      "Traceability Records"
    ],
    inspection_type: "Continuous or Daily USDA Inspection",
    risk_level: "High",
    next_steps: [
      "Engage USDA FSIS for establishment approval path",
      "Develop and validate HACCP system",
      "Implement sanitation and recordkeeping controls",
      "Set up lot traceability and recall procedures",
      "Prepare for USDA inspection program"
    ]
  },
  BEVERAGE_MANUFACTURING: {
    category: "Beverage Manufacturing",
    agencies: ["FDA", "State Department of Agriculture", "OSHA", "EPA (as applicable)"],
    regulations: [
      "Food Safety Modernization Act (FSMA)",
      "21 CFR Part 117 (cGMP and Preventive Controls)",
      "21 CFR Part 101 (Food Labeling)"
    ],
    registrations: [
      "Business Registration",
      "EIN",
      "FDA Food Facility Registration"
    ],
    permits: [
      "State Beverage Manufacturing License",
      "Water/Wastewater Permit (as applicable)"
    ],
    documents: [
      "Food Safety Plan",
      "Water Quality Records",
      "Recall Plan",
      "Label Compliance Records",
      "Batch Records"
    ],
    inspection_type: "Routine FDA or State Inspection",
    risk_level: "Medium",
    next_steps: [
      "Confirm beverage-specific state licensing",
      "Validate source water and sanitation controls",
      "Implement preventive controls and records",
      "Review product labels for compliance",
      "Prepare for FDA/state inspection"
    ]
  }
};

export function validateNaicsCode(value) {
  const code = value.trim();
  if (!code) return "Please enter a NAICS code.";
  if (!/^\d{6}$/.test(code)) return "Please enter a valid 6-digit NAICS code.";
  return "";
}

export function resolveCategoryKey(naicsCode) {
  if (naicsCode === "311611") return "MEAT_PROCESSING";
  if (naicsCode.startsWith("722")) return "FOOD_SERVICE";
  if (naicsCode.startsWith("311")) return "MANUFACTURING";
  if (naicsCode.startsWith("312")) return "BEVERAGE_MANUFACTURING";
  return null;
}

function buildPrefixRecord(naicsCode, categoryKey) {
  const base = CATEGORY_DEFAULTS[categoryKey];
  return {
    business_type: `General ${base.category} Operation`,
    ...base,
    matched_rule: `Prefix-based default for ${naicsCode}`
  };
}

export function resolveComplianceRecord(naicsCode, dataset) {
  const exactMatch = dataset[naicsCode];
  if (exactMatch) {
    return { source: "exact", data: exactMatch };
  }

  const categoryKey = resolveCategoryKey(naicsCode);
  if (!categoryKey) return { source: "unsupported", data: null };

  return {
    source: "prefix",
    data: buildPrefixRecord(naicsCode, categoryKey)
  };
}
